const translation = {
  errorBoundary: {
    title: '出了点问题',
    description: '无法显示此页面。您的数据未被更改。请重试或重新加载页面。',
    offlineTitle: '无法连接到平台',
    offlineDescription: '与平台的连接失败。请检查您的网络连接后重试。',
    retry: '重试',
    reload: '重新加载页面',
  },
  notifications: {
    empty: '暂无新通知',
    clearAll: '清除全部',
    clearAllConfirm: '清除所有通知？此操作无法撤销。',
    clearAllFailed: '清除通知失败',
    markReadFailed: '无法将通知标记为已读',
    delete: '删除通知',
    deleteFailed: '删除通知失败',
    reminderTitle: '测量即将到期',
    reminderBody: '快到为{{programme}}记录{{measurement}}的时间了。',
    cleared: '通知已清除',
    deleted: '通知已删除',
  },
  dataGrid: {
    noResultsFound: '未找到结果',
    selectAll: '全选',
    selectRow: '选择{{name}}',
    rowLabel: '第 {{id}} 行',
    ascending: '升序',
    descending: '降序',
    sortByColumn: '按{{column}}排序（{{direction}}）',
  },
  manageUsers: {
    title: '组织成员',
    subtitle: '您组织中的成员，以及他们在这里的角色。',
    nameColumn: '姓名',
    emailColumn: '邮箱',
    rolesColumn: '角色',
    rolesPlaceholder: '添加角色',
    rolesSaved: '角色已更新',
    rolesFailed: '角色更新失败',
    filterLabel: '角色',
    filterAll: '全部角色',
    filterNone: '无角色',
    noTenantNotice: '成员按机构列出，而此账户不属于任何机构。',
    noTenantTitle: '尚无机构',
  },
      navGroups: {
        general: '常规',
        programmes: '项目',
        mySettings: '设置',
      },
      navigation: {
    ownEnvironment: '我自己的环境',
    platformEnvironment: '平台管理',
    switchEnvironment: '切换环境',
    manageUsers: '组织成员',
        dashboard: '我的仪表板',
        foodTracking: '饮食追踪',
        activity: '活动',
        sleep: '睡眠',
        weightBmi: '体重/BMI',
        wellnessValues: '健康值',
        progress: '进度',
        insights: '洞察',
        myCommunity: '我的社区',
        coaches: '教练',
        coaching: '辅导',
        myProgrammes: '我的计划',
        programs: '计划',
        researchData: '研究数据',
        education: '教育',
        analytics: '分析',
        billing: '账单',
        shareData: '分享数据',
        settings: '语言和地区',
        profile: '我的档案',
        logout: '退出',
        masterData: '主数据',
        metabolicMeasurements: '我的测量',
        weeklyData: '每周数据',
        tenantSettings: '租户设置',
        dataManagement: '数据设置',
        manageProgrammes: '计划设置',
        manageProgrammeMeasurements: '计划数据',
        manageRoles: '角色',
        dataPermissions: '数据权限',
        dataProviders: '数据来源',
        adminDataProviders: '所有 FHIR 服务器',
        uploadPDF: '上传 PDF',
        savedDocuments: '我的文件',
        pinSidebar: '固定侧边栏',
        unpinSidebar: '取消固定侧边栏',
      },
      devLogin: {
        subtitle: '本地开发 — 已绕过身份验证',
        roles: {
          globalAdmin: '全局管理员',
          tenantAdmin: '租户管理员',
          coach: '教练',
          member: '成员',
          remoteMember: '远程成员',
        },
      },
      brand: {
        loading: '加载中',
      },
      auth: {
        platformName: 'My Lifestyle Platform',
        poweredBy: '由 Stichting Je Leefstijl Als Medicijn 提供支持',
        platformLogin: '平台登录',
        password: '密码',
        signIn: '登录',
        signUp: '注册',
        forgotPassword: '忘记密码？',
        requestAccess: '请求访问',
        demoMode: '演示模式 - 使用任何凭据',
        demoDescription: '访问您完整的生活方式健康仪表板',
        loginSuccess: '登录成功！正在重定向...',
        sessionExpired: {
          title: '您的会话已过期',
          message: '为保护您的数据，系统已自动将您登出。请重新登录以继续。',
          signIn: '重新登录',
          dismiss: '稍后',
        },
      },
      dashboard: {
        refreshData: '刷新数据',
        lastSynced: '上次同步 {{time}}',
        justSynced: '刚刚同步',
        signInRequired: '您需要登录才能查看仪表板。',
        unableToLoad: '无法加载仪表板数据。',
        activeProgrammes: '活跃计划',
        programmes: '计划',
        trackedMeasurements: '跟踪的测量',
        targetsConfigured: '已配置的目标',
        measurementTrends: '测量趋势',
        measurementTrendsSubtitle: '堆叠视图以一起探索所有测量。',
        timeRange: '时间范围：',
        oneYear: '1年',
        days: '{{count}}天',
        noMeasurementData: '尚无测量数据',
        noMeasurementDataSubtitle: '当新数据点到达时，时间线将自动更新。',
        programmeTargets: '计划目标',
        programmeTargetsSubtitle: '目标由您的计划管理员设置，并在此处显示以供参考。',
        noProgrammeMeasurements: '尚无可用的计划测量。',
        latestValue: '最新值',
        targetRange: '目标范围',
        noMeasurementRecorded: '尚未记录测量',
        onTarget: '符合目标',
        needsAttention: '需要关注',
        noTargetSet: '未设置目标',
        min: '最小：{{value}} {{unit}}',
        max: '最大：{{value}} {{unit}}',
        rangeTarget: '{{min}} - {{max}} {{unit}}',
        scopeFrom: '显示自此日期起的测量值',
        scopeTo: '显示截至此日期（含）的测量值',
        saved: '您的布局已保存。',
        settingsSaved: '{{name}} 已保存。',
        deleted: '{{name}} 已删除。',
      },
      profile: {
        welcomeNewUser: '欢迎！请完善您的个人资料',
        newUserMessage: '请填写以下信息，帮助我们为您提供个性化体验。',
        continueToDashboard: '继续前往仪表板',
        myProfile: '我的个人资料',
        reviewDetails: '查看并更新您的个人详细信息',
        completeProfile: '完善您的个人资料',
        keepUpdated: '保持信息更新以获得更好的个性化见解',
        accountInformation: '账户信息',
        referenceCode: '参考代码',
        anonymousSharingId: '您的匿名共享ID',
        activeSince: '活跃自',
        personalDetails: '个人详细信息',
        firstName: '名',
        lastName: '姓',
        nickname: '昵称',
        nicknamePlaceholder: '您希望如何被称呼？',
        birthDate: '出生日期',
        gender: '性别',
        genderMale: '男',
        genderFemale: '女',
        genderPrefernottosay: '不愿透露',
        emailAddress: '电子邮件地址',
        emailPlaceholder: '您的邮箱@示例.com',
        emailHelper: '用于接收更新和通知的电子邮件地址',
        aboutMe: '关于我',
        headline: '标题',
        headlinePlaceholder: '关于您自己的简短标语',
        bio: '简介',
        bioPlaceholder: '告诉我们一些关于您的信息',
        motivation: '动机',
        motivationPlaceholder: '是什么激励您使用这个平台？',
        privacyDataSharing: '隐私与数据共享',
        sharingPreference: '共享偏好',
        sharingHelper: '选择您希望如何在此平台上共享数据',
        shareAnonymously: '匿名共享我的数据',
        shareWithName: '共享我的数据及姓名',
        doNotShare: '不共享我的数据',
        notificationPreferences: '通知偏好',
        pushNotifications: '推送通知',
        pushNotificationsDesc: '在您的设备上接收推送通知',
        emailNotifications: '电子邮件通知',
        emailNotificationsDesc: '通过电子邮件接收通知',
        inAppNotifications: '应用内通知',
        inAppNotificationsDesc: '在应用程序内接收通知',
        programmeNotifications: '计划通知',
        programmeNotificationsHelper: '为每个计划选择希望在计划测量前多少分钟收到提醒。关闭某个计划的通知即可完全停止该计划的提醒。',
        reminderTime: '提醒时间',
        reminderTimeCustomLabel: '分钟（1-180）',
        reminderNoScheduledMeasurements: '该计划目前没有已安排的测量项目。',
        notificationsLabel: '通知',
        reminderLoadFailed: '加载提醒设置失败',
        saving: '保存中...',
        saveProfile: '保存个人资料',
        saveSuccess: '个人资料保存成功',
        errorLoading: '加载个人资料失败',
        errorSaving: '保存个人资料失败',
      },
      uploadPDF: {
        title: '上传文档',
        description: '您可以在这里上传 PDF 文件。',
        documentType: '文档类型',
        selectDocumentType: '选择文档类型',
        labTest: '实验室检查',
        insuranceDocument: '保险文件',
        idCard: '身份证',
        enabledAIExtraction: '已启用：上传后我们将提取观测数据。',
        disabledAIExtraction: '已禁用：我们只会存储文档。',
        descriptionTitle: '描述',
        descriptionLabel: '描述',
        descriptionPlaceholder: '例如：全科医生就诊后的血液检查 (24/01/2026)',
        filenameTitle: '文件名',
        filenameLabel: '文件名',
        filenamePlaceholder: '请输入文件名',
        aiExtractionTitle: 'AI 提取',
        aiExtractionSelectTypeHelper: '选择一个文档类型以查看 AI 提取选项。',
        dropFilesPrompt: '将文件拖放到这里，或从您的设备中选择',
        chooseFiles: '选择文件',
        deleteDocument: '清除选择',
        filesSelected: '已选择文件',
        uploadButton: '上传',
        documentSuccessfullyUploaded: '文档上传成功。',
        aiExtractionNotAvailable: '此文档类型不支持 AI 提取',
      },
      savedDocuments: {
        fileName: '文件名',
        fileType: '文件类型',
        uploadedBy: '上传者',
        description: '描述',
        uploadDate: '上传日期',
        status: '状态',
        inProgress: '进行中',
        readyForReview: '待审核',
        committed: '已提交',
        inReview: '审核中',
        uploaded: '已上传',
        failed: '失败的',
        unknownStatus: '失败的',
        noStatus: '无状态',
        noDocuments: '未找到文档',
        yourDocuments: '您的文档',
        viewPreviouslyUploaded: '查看之前上传的文档',
        documents: '文档',
        filter: '筛选',
        allTypes: '全部',
        preview: '预览',
        uploadNewDocument: '上传新文档',
        review: '审查',
        delete: '删除',
        updateDocument: '更新文档',
        update: '更新',
        cancel: '取消',
        save: '保存',
        documentSuccessfullyDeleted: '文档删除成功',
        deleteError: '删除文档时出错',
        deleteErrorPartial: '{{count}} 个文档删除失败',
        downloadError: '文档下载失败',
        deleteConfirm: '确定要删除 {{count}} 个文档吗？',
        deleting: '正在删除...',
        close: '关闭',
        download: '下载',
        types: {
          bloodTestReport: '血液检测报告',
          stoolTestReport: '粪便检测报告',
          consultationNote: '会诊记录',
        },
        updateSuccess: '文档已更新',
        updateError: '无法更新文档',
      },
      documentExtractionReview: {
        aiChip: 'TRPI AI 驱动',
        title: '提取审核',
        previewTitle: '文档预览',
        preview: {
          loadingDocument: '正在加载文档...',
          preparingPdf: '正在准备 PDF...',
          zoom: '缩放 {{percent}}%',
          zoomControlsAria: '缩放控件',
          zoomOut: '缩小',
          fit: '适应',
          zoomIn: '放大',
          fullscreen: '全屏',
          exitFullscreen: '退出全屏',
          unavailable: '此文件不支持应用内预览，请下载该文件以查看。',
          pageOf: '第 {{current}} 页，共 {{total}} 页',
          prevPageAria: '上一页',
          nextPageAria: '下一页',
        },
        subtitle: '在提交到核心观察之前，请审核提取的数值。',
        committedInfo: '此文档无法再编辑，但仍可查看提取的数值。',
        commit: {
          action: '提交到核心',
          committed: '已提交',
          aria: '提交提取的测量值',
          success: '文档已提交',
          error: '提交文档失败',
        },
        tooltips: {
          download: '下载',
          fullscreen: '全屏',
          exitFullscreen: '退出全屏',
        },
        aria: {
          download: '下载文档',
          fullscreen: '切换右侧面板全屏',
        },
        updatedAt: '更新于：{{date}}',
        failedMessage: '提取失败。你仍可以预览文档。如问题持续，请联系支持。',
        loadDataError: '加载提取数据时出错。请重试。',
        extractionInProgress: '提取正在进行中。',
        notExtracted: '未提取',
        timeline: {
          button: '查看时间线',
          title: '提取时间线',
        },
        loading: '正在加载提取...',
        providers: {
          organisation: '组织',
          practitioner: '医生',
          searchPlaceholder: '搜索现有{{type}}',
          notInList: '不在列表中',
        },
        sections: {
          measurements: {
            title: '提取的测量值',
            columns: {
              measurementName: '提取的测量项',
              valueExtracted: '提取的数值',
              unitExtracted: '单位（提取）',
              ucumCode: 'UCUM 代码',
              ucumName: 'UCUM 名称',
              loincCode: 'LOINC 代码',
              loincName: 'LOINC 名称',
              referenceRangeMin: '参考下限',
              referenceRangeMax: '参考上限',
            },
            actions: {
              resetColumns: '重置列可见性',
              edit: '编辑测量值',
              save: '保存测量值',
              cancel: '取消测量值更改',
              deleteRow: '删除行',
              deleteRowDisabled: '启用编辑模式以删除行',
              addRow: '添加行',
            },
            aria: {
              resetColumns: '重置列可见性',
              edit: '编辑提取的测量值',
              save: '保存提取的测量值',
              cancel: '取消提取测量值更改',
              deleteRow: '删除第 {{id}} 行',
            },
            toasts: {
              addSuccess: '已添加测量行',
              addError: '无法添加测量行',
              deleteSuccess: '测量已删除',
              deleteError: '无法删除测量',
            },
          },
          organisation: {
            title: '执行组织',
            status: {
              matchFound: '已匹配组织',
              noMatch: '未匹配组织',
            },
            tooltips: {
              validation: '请填写正确的值',
              save: '保存组织信息',
              cancel: '取消组织更改',
            },
            aria: {
              edit: '编辑执行组织',
              save: '保存执行组织更改',
              cancel: '取消提取的组织更改',
            },
            fields: {
              name: '名称',
              address: '地址',
              houseNumber: '门牌号',
              city: '城市',
              postalCode: '邮编',
              countryCode: '国家代码',
              contactPerson: '联系人',
              phoneNumber: '电话号码',
              emailAddress: '电子邮箱',
            },
          },
          practitioner: {
            title: '申请医生',
            status: {
              matchFound: '已匹配医生',
              noMatch: '未匹配医生',
            },
            tooltips: {
              validation: '请填写正确的值',
              save: '保存医生信息',
              cancel: '取消医生更改',
            },
            aria: {
              edit: '编辑申请医生',
              save: '保存申请医生更改',
              cancel: '取消提取的医生更改',
            },
            fields: {
              name: '姓名',
              role: '角色',
              phoneNumber: '电话号码',
              emailAddress: '电子邮箱',
            },
          },
        },
        sectionSaved: '您的更改已保存。',
        sectionSaveFailed: '无法保存您的更改。',
      },
      content: {
        billing: {
          title: '账单与支付',
          description: '管理订阅、支付和高级功能以增强功能。',
          viewBilling: '查看账单',
        },
      },
      masterData: {
        tabs: {
          measurements: '测量',
          units: '单位',
        },
        measurementList: {
          subtitle: '平台已知的所有代码：LOINC 版本和平台自有的代码。打开其中一个，查看它的轴和单位。',
        },
        measurementCodes: {
          list: {
            columns: {
              name: '名称',
              code: '代码',
              codeSystem: '代码体系',
              status: '状态',
              inUse: '使用中',
            },
            yes: '是',
            no: '否',
            views: {
              label: '显示',
              all: '所有代码',
              inUse: '使用中',
            },
            systemFilter: '代码体系',
            systemAll: '所有代码体系',
          },
          general: {
            code: '代码',
            codeSystem: '代码体系',
            name: '名称',
            status: '状态',
            release: '版本',
            releaseValue: '{{version}}，于 {{date}} 加载',
            releaseNone: '不适用：平台自有代码没有版本。',
            releaseUnknown: '此代码未记录。',
            valueKind: '值的类型',
            quantityKind: '量的类型',
          },
          axes: {
            title: '测量的内容',
            component: '成分',
            analyte: '分析物',
            property: '属性',
            time: '时间',
            system: '体系',
            scale: '标度',
            method: '方法',
            noMethod: '无',
            unknown: '平台没有这个代码的轴信息。它不与任何内容归为一组。',
          },
          groups: {
            title: '归为一组的内容',
            nothing: '在这一层级不与任何内容归为一组。',
          },
          levels: {
            THIS_CODE: '仅此代码',
            ANY_METHOD: '同一事物，不论方法',
          },
          trace: {
            title: '追溯一个值',
            help: '输入成员提供给你的值编号。你会看到它是如何记录的，以及它来自哪里。',
            number: '值编号',
            show: '显示来源',
          },
          dialog: {
            addTitle: '添加平台测量项',
            editTitle: '编辑 {{name}}',
            name: '名称',
            code: '代码',
            codeHelp: '以 X 开头，例如 X-HAPPY-1。两个测量项不能共用同一个代码。',
            codeSystem: '代码体系',
            analyteHelp: '留空则使用成分。',
            noPart: '没有匹配的 Part。输入名称即可添加一个。',
            partsFailed: '无法读取这些 Part。请重新输入再试。',
            addPart: '将“{{name}}”添加为新的 Part',
            partAdded: '已将 {{name}} 添加为 Part',
            newPropertyKind: '新属性的量的类型',
            newPropertyKindHelp: '仅在你于上方添加新属性时使用。',
            noKind: '无',
          },
        },
        dimensionWords: {
          length: '长度',
          mass: '质量',
          time: '时间',
          amountOfSubstance: '物质的量',
          electricCurrent: '电流',
          temperature: '温度',
          luminousIntensity: '发光强度',
          dimensionless: '无量纲',
          per: '每',
        },
        unitTabs: {
          label: '单位与摩尔质量',
          units: '单位列表',
          molarMasses: '摩尔质量',
        },
        unitList: {
          subtitle: '可用于记录数值的单位（适用于每个组织）及其量纲。哪些测量项使用哪个单位，在各测量项中设置。',
          noUcum: '无 UCUM 代码',
          noDimension: '无量纲信息',
          columns: {
            quantityKinds: '量',
          },
        },
        unitDialog: {
          dimensionHelp: '没有 UCUM 代码的单位，在此输入其量纲。量纲相同的单位可以互相换算。',
          noDimension: '无量纲信息',
          ucumHelp: '平台所持 UCUM 版本中的代码，例如 kg。两个单位不能共用同一个代码。',
          noUcum: '此单位没有 UCUM 代码。如果有，请添加，例如 kg。',
          workedOut: '根据 UCUM 代码推算。',
          workedOutAfterSave: '保存时推算。',
          quantityKinds: '可表示的量',
          quantityKindsHelp: '如果某单位可以表示测量项所指的量，它就适用于该测量项。取自 QUDT，或在此选择。',
          dimensionsFailed: '无法读取量纲，因此无法选择。',
          dimensionsRetry: '重试',
        },
        measurementUnits: {
          add: '关联单位',
          edit: '编辑关联',
          remove: '移除关联',
          isDefault: '标准',
          columns: {
            isDefault: '标准',
            conversion: '换算为标准单位',
            approvedBy: '批准人',
            validMinimum: '有效下限',
            validMaximum: '有效上限',
          },
          confirm: '确认系数',
          confirmedToast: '已确认 {{unit}} 的系数',
          factor: '1 {{from}} = {{multiplier}} {{to}}',
          factorWithOffset: '({{from}} + {{offset}}) × {{multiplier}} = {{to}}',
          viaAlgebra: '根据 UCUM 代码推算。',
          viaMolarMass: '通过 {{analyte}} 的摩尔质量，{{mass}} g/mol。来源：{{source}}。',
          formula: '{{factor}}。{{via}}',
          approved: '{{by}}, {{date}}',
          notApproved: '尚未批准',
          unavailable: {
            dimensionDiffers: '没有系数：此单位的量纲与标准单位不同。',
            noCanonicalUnit: '尚无系数：此测量没有标准单位。',
            noMolarMass: '暂无系数：尚未记录该分析物的摩尔质量。',
            noDimension: '没有系数：此单位没有量纲。',
          },
          enterMolarMass: '输入摩尔质量',
          removeDialog: {
            title: '移除此关联？',
          },
        },
        unitLinkDialog: {
          isDefault: '标准单位：数值以它显示，并检查其范围',
          isDefaultHelp: '测量项的第一个单位就是它的标准单位。只能有一个。',
          otherDefault: '另一个单位是标准单位。请先在那里将其关闭。',
          validMinimum: '有效最小值',
          validMaximum: '有效最大值',
          validHelp: '可选。可记录的最低值，单位为 {{unit}}。其他单位的数值会先换算。',
          rangeWrong: '最小值高于最大值。',
        },
        molarMasses: {
          title: '摩尔质量',
          subtitle: '质量浓度通过摩尔质量与同一分析物的摩尔浓度对应。每个质量都有其来源。',
          add: '添加摩尔质量',
          edit: '编辑摩尔质量',
          remove: '移除摩尔质量',
          addTitle: '添加摩尔质量',
          editTitle: '编辑 {{name}} 的摩尔质量',
          columns: {
            analyte: '分析物',
            gramsPerMole: '克每摩尔',
            source: '来源',
          },
          analyte: '分析物',
          analyteHelp: '按名称或 Part 编号搜索，例如葡萄糖。',
          gramsPerMole: '克每摩尔',
          massHelp: '葡萄糖为：180.156。',
          massWrong: '请输入大于 0 的数，小数点前后最多各十位。',
          source: '来源',
          sourceHelp: '该数值的出处：LOINC 组、ChEBI 或 PubChem 标识符，或参考文献。',
          removeDialog: {
            title: '移除此摩尔质量？',
            message: '{{name}} 不再有摩尔质量。使用它的系数将无法再推算。',
          },
        },
      },
      tenantSettings: {
        title: 'Tenant 设置',
        subtitle: '管理设置',
        loadError: '无法加载租户设置。您可能没有权限查看此租户。',
        generalInfo: '常规信息',
        tenantName: 'Tenant 名称',
        organisation: '组织',
        organisationHelper: '组织无法更改',
        tenantId: 'Tenant ID',
        yourRole: '您的角色',
        roleDescription: '您在此组织中的角色是 {{role}}。',
        permissionsConfigured: '此角色可执行的操作由组织自行配置。管理员可在角色页面查看和更改。',
        saveName: '保存名称',
        nameSaved: '租户名称已更新。',
        saveError: '无法保存名称。您可能没有更改权限。',
      },
      communityUsers: {
        title: '社区用户',
        subtitle: '平台中拥有账户的所有用户。个人详细信息仅根据每个用户的隐私偏好显示。',
        loadError: '加载社区用户失败。请重试。',
        view: '查看',
        noUsersTitle: '暂无共享用户',
        noUsersNotice: '还没有人开放数据供查看。',
      },
      adminDashboard: {
        menuItems: {
          questionnaires: '问卷',
          tenants: '租户',
          organisations: '组织',
          users: '系统用户',
        },
        users: {
          title: '系统用户',
          comingSoon: '用户管理即将推出...',
        },
      },
      organisationDialog: {
        titleCreate: '创建新组织',
        titleEdit: '编辑组织',
        emailInvalid: '请输入电子邮件地址，例如 name@example.org',
        dateInvalid: '请输入日期',
        legalNameRequired: '法定名称为必填项',
        createError: '创建组织失败。请检查唯一字段是否已被使用。',
        fields: {
          legalName: '法定名称',
          tradeName: '商业名称',
          taxId: '税务ID',
          referenceCode: '参考代码',
          emailAddress: '电子邮箱',
          phoneNumber: '电话号码',
          website: '网站',
          practiceCode: '执业代码',
          chamberOfCommerceNumber: '商会编号',
          subscriptionDate: '订阅日期',
          active: '活跃',
        },
        actions: {
          create: '创建',
        },
      },
      organisationList: {
        title: '组织',
        addButton: '添加组织',
        updateSuccess: '组织更新成功',
        updateError: '组织更新失败',
        columns: {
          legalName: '法定名称',
          tradeName: '商业名称',
          taxId: '税号',
          referenceCode: '参考代码',
          emailAddress: '电子邮箱',
          phoneNumber: '电话',
          website: '网站',
          practiceCode: '业务代码',
          chamberOfCommerceNumber: '商会编号',
          subscriptionDate: '订阅日期',
          status: '状态',
        },
        statusLabels: {
          active: '活跃',
          inactive: '非活跃',
        },
        edit: '编辑',
        deactivate: '停用',
        alreadyInactive: '已停用。可通过“编辑”重新启用。',
        deactivateTitle: '停用组织',
        deactivateMessage: '{{name}} 将被标记为停用。不会删除任何内容，您可以通过“编辑”重新启用。',
        deactivated: '组织已停用',
        created: '组织已创建',
      },
      questionnaireEditor: {
        questionsCount: '问题 ({{count}})',
        addQuestionButton: '添加问题',
        emptyState: {
          message: '还没有问题。添加您的第一个问题！',
          button: '添加问题',
        },
        question: {
          prefix: '问题',
          required: '必填',
          identity: '身份：',
          optionsLabel: '选项：',
        },
        tooltips: {
          edit: '编辑',
          delete: '删除',
        },
        dialog: {
          titleNew: '新建问题',
          titleEdit: '编辑问题',
          questionType: '问题类型',
          questionPrompt: '问题内容',
          requiredQuestion: '必填问题',
          identityField: '这是一个身份字段（用于用户入职）',
          identityFieldType: '身份字段类型',
          listOptionsTitle: '列表选项',
          addOptionButton: '添加选项',
          codeLabel: '代码',
          codePlaceholder: '例如，SAT_HIGH',
          valueLabel: '显示值',
          valuePlaceholder: '例如，非常满意',
          emptyOptions: '为下拉问题添加至少一个选项',
          cancel: '取消',
          save: '保存',
          create: '创建',
          removeOption: '移除选项',
        },
        deleteDialog: {
          title: '删除问题',
          message: '您确定要删除此问题吗？这也将删除与之关联的所有答案。',
          cancel: '取消',
          delete: '删除',
        },
        messages: {
          updateSuccess: '问题更新成功',
          createSuccess: '问题创建成功',
          deleteSuccess: '问题删除成功',
          saveError: '保存问题失败',
          deleteError: '删除问题失败',
        },
        questionTypes: {
          text: '文本',
          number: '数字',
          date: '日期',
          list: '列表/下拉菜单',
          boolean: '是/否',
        },
        identityTypes: {
          first_name: '名字',
          last_name: '姓氏',
          email: '电子邮箱',
          date_of_birth: '出生日期',
        },
      },
      questionnaireList: {
        title: '问卷',
        newButton: '添加问卷',
        table: {
          name: '名称',
          description: '描述',
          status: '状态',
          version: '版本',
          publicLink: '公开链接',
        },
        statusLabels: {
          active: '活跃',
          inactive: '非活跃',
        },
        dialog: {
          titleNew: '添加问卷',
          titleEdit: '编辑问卷',
          name: '名称',
          description: '描述',
          active: '活跃',
          create: '创建',
          nameRequired: '请输入名称',
          publicLink: '公开链接',
          noPublicLink: '此问卷还没有公开链接。',
          newLink: '保存时生成新链接。当前链接将失效。',
          makeLink: '保存时生成公开链接',
        },
        deleteDialog: {
          title: '移除问卷',
          message: '将移除 {{name}} 及其问题。已有人作答的问卷不会被移除；请改为停用。',
          delete: '移除',
        },
        messages: {
          updateSuccess: '问卷更新成功',
          createSuccess: '问卷创建成功',
          deleteSuccess: '问卷已移除',
          saveError: '保存问卷失败',
          linkCopied: '链接已复制到剪贴板',
          copyFailed: '无法复制链接',
        },
        copyLink: '复制链接',
        copyLinkOf: '复制 {{name}} 的公开链接',
        noLink: '无',
        edit: '编辑',
        delete: '移除',
        noOrganisationTitle: '尚无组织',
        noOrganisationNotice: '问卷属于某个组织，而此账户不属于任何组织。',
      },
      submissionViewer: {
        table: {
          id: 'ID',
          status: '状态',
          email: '电子邮箱',
          name: '姓名',
          submittedAt: '提交时间',
        },
        statusLabels: {
          submitted: '已提交',
          draft: '草稿',
          scored: '已评分',
          abandoned: '已放弃',
        },
        dialog: {
          title: '提交 - 答案',
          submissionDetails: '提交详情',
          status: '状态',
          submittedAt: '提交时间',
          notYetSubmitted: '尚未提交',
          email: '电子邮箱',
          name: '姓名',
          answersCount: '答案 ({{count}})',
          noAnswers: '尚未提交答案。',
          questionPrefix: '问题 {{number}}',
          close: '关闭',
          unknownQuestion: '已不在此问卷中的问题',
        },
        booleanValues: {
          yes: '是',
          no: '否',
        },
        answersFailed: '无法加载答案',
        openAnswers: '{{sent}} 提交的回答',
      },
      tenantList: {
        title: '租户',
        addButton: '添加租户',
        saveError: '保存租户失败',
        noOrganisationsWarning: '没有可用的组织。请先创建组织再添加租户。',
        table: {
          id: 'ID',
          name: '名称',
          organisation: '组织',
        },
        tooltips: {
          edit: '编辑',
        },
        dialog: {
          titleCreate: '创建租户',
          titleEdit: '编辑租户',
          tenantName: '租户名称',
          organisation: '组织',
          create: '创建',
          nameRequired: '请输入名称',
          organisationRequired: '请选择组织',
          organisationLocked: '租户始终属于其组织',
        },
        messages: {
          created: '已添加租户',
          updated: '已保存租户',
        },
      },
      publicQuestionnairePage: {
        loading: '加载中...',
        invalidLink: '无效的问卷链接',
        notFound: '未找到问卷或不再活跃',
        checkLink: '请检查链接并重试。',
        thankYou: '谢谢！',
        submitted: '您的回答已成功提交。',
        newAccountCreated: '已为您创建新账户。请查看您的电子邮件以获取登录说明。',
        progress: '进度',
        questions: '个问题',
        required: '此字段为必填项',
        identityFieldInfo: '此信息将用于创建您的账户',
        submitButton: '提交问卷',
        submitting: '提交中...',
        autoSave: '您的答案会在输入时自动保存',
        missingRequired: '请回答所有必填问题（还剩 {{count}} 个）',
        submitError: '提交问卷失败。请重试。',
        placeholders: {
          text: '输入您的答案...',
          number: '输入一个数字...',
          email: '输入您的电子邮件',
          firstName: '输入您的名字',
          lastName: '输入您的姓氏',
          dateOfBirth: '输入您的出生日期',
        },
        booleanValues: {
          yes: '是',
          no: '否',
        },
        answerSaveFailed: '无法保存您的回答，请重试。',
      },
      manageProgrammeMeasurements: {
        title: '项目测量',
        tenant: '租户',
        addButton: '添加项目测量',
        noProgrammes: '没有可用的项目。请先创建一个项目。',
        noOrganisationTitle:
          '尚无机构',
        noOrganisation: '项目测量属于机构，而此账户不属于任何机构。',
        rolesUnknownTitle: '无法读取你的角色',
        rolesUnknownNotice:
          '没有角色，此页面无法判断该显示哪个机构，这与不属于任何机构不同。',
        table: {
          programmeName: '项目名称',
          measurementName: '测量名称',
          loincCode: 'LOINC 代码',
          minimumTarget: '最小目标',
          maximumTarget: '最大目标',
          defaultUnit: '默认单位',
          reminder: '提醒',
          everyWeeks: '每 {{count}} 周：{{days}}',
        },
        actions: {
          edit: '编辑',
          delete: '删除',
        },
        dialog: {
          titleAdd: '添加项目测量',
          titleEdit: '编辑项目测量',
          programme: '项目',
          measurement: '测量',
          minimumTarget: '最小目标',
          maximumTarget: '最大目标',
          defaultUnit: '默认单位',
          selectProgramme: '选择一个项目',
          selectMeasurement: '选择一个测量',
          measurementSearchHint: '请输入名称或代码的至少三个字母。',
          measurementNoMatch: '没有匹配的测量项。',
          measurementSearchFailed: '无法读取这些测量项。请重新输入再试。',
          selectUnit: '选择一个单位',
          repeatEvery: '每',
          weeks: '周',
          repeatOn: '重复于',
          ends: '结束',
          endsProgrammeEnd: '项目结束时',
          endsOn: '在',
          endsAfter: '经过',
          occurrences: '次',
          timeOfDay: '时间',
          timeOfDayOptional: '可选',
          selectWeekdaysFirstWarning: '请先选择一个星期几',
          recurrenceHint: '不选择任何日期即表示不记录计划。周数从项目开始的那一周起计算。',
          programmeHasNoEndDate: '此项目没有结束日期，因此将无限重复',
          save: '保存',
          update: '更新',
        },
        deleteConfirm: '您确定要从项目“{{programmeName}}”中删除测量“{{measurementName}}”吗？',
        deleteTitle: '从项目中移除此测量？',
        messages: {
          loadRolesFailed: '加载租户角色失败',
          loadDataFailed: '加载数据失败',
          partlyRead: '部分项目的测量数据无法读取，因此此列表可能不完整。',
          noTenantSelected: '未选择租户',
          selectProgrammeError: '请选择一个项目',
          selectMeasurementError: '请选择一个测量',
          selectUnitError: '请选择一个默认单位',
          recurrenceIntervalError: '重复间隔必须是 1 到 52 之间的整周数',
          recurrenceEndDateError: '请选择不早于项目开始日期的结束日期',
          recurrenceOccurrencesError: '次数必须是 1 到 520 之间的整数',
          deleteSuccess: '项目测量删除成功',
          addSuccess: '项目测量添加成功',
          addFailed: '添加项目测量失败',
          updateSuccess: '项目测量更新成功',
          updateFailed: '更新项目测量失败',
          notAllowed: '你无权更改此项。',
        },
      },
      manageProgrammeDialog: {
        titleCreate: '创建新项目',
        titleEdit: '编辑项目',
        programmeName: '项目名称',
        programmeNameRequired: '项目名称为必填项',
        description: '描述',
        targetAudience: '目标受众',
        startDate: '开始日期',
        startDateRequired: '开始日期为必填项',
        startDateLocked: '创建后开始日期不可更改',
        endDate: '结束日期',
        endDateHelper: '如为持续项目,请留空',
        endDateError: '结束日期必须晚于开始日期',
        startDatePast: '开始日期不能早于今天',
        endDatePast: '结束日期不能早于今天',
        saveChanges: '保存更改',
        createProgramme: '创建项目',
        saveFailed: '保存项目失败',
        banner: {
          label: '横幅',
          choose: '选择图片',
          remove: '移除横幅',
          none: '尚未设置横幅。成员会看到以 tenant 颜色显示的项目名称。',
          accepted: 'PNG、WebP 或 JPEG，最大 2 MB，800 × 200 至 6000 × 6000 像素。',
          refused: '无法使用此文件。请选择最大 2 MB、介于 800 × 200 与 6000 × 6000 像素之间的 PNG、WebP 或 JPEG 图片。',
          saveFailed: '横幅无法保存。请重试。',
        },
      },
      manageProgrammes: {
        title: '项目',
        addButton: '添加项目',
        tenant: '租户',
        loadRolesFailed: '加载租户角色失败',
        loadProgrammesFailed: '加载项目失败',
        table: {
          programmeName: '项目名称',
          description: '描述',
          target: '目标',
          startDate: '开始日期',
          endDate: '结束日期',
        },
        actions: {
          edit: '编辑',
          delete: '删除',
        },
        deleteDialog: {
          title: '删除项目',
          message: '您确定要删除项目"{{programmeName}}"吗？此操作无法撤销。',
          delete: '删除',
        },
        messages: {
          createSuccess: '项目创建成功',
          updateSuccess: '项目更新成功',
          deleteSuccess: '项目删除成功',
        },
        ongoing: '进行中',
        loadFailedTitle: '无法读取项目',
        noOrganisationNotice: '项目属于机构，而此账户不属于任何机构。',
        noOrganisationTitle: '尚无机构',
        rolesUnknownNotice: '没有角色，此页面无法判断你管理什么，这与什么都不管理不同。',
        rolesUnknownTitle: '无法读取你的角色',
      },
      programmesOverview: {
        title: '可用项目',
        loadFailed: '加载项目失败',
        enrollFailed: '注册项目失败',
        enroll: '注册',
        unenroll: '退出项目',
        unenrollFailed: '退出项目失败',
        preview: '预览',
        table: {
          programmeName: '项目名称',
          target: '目标',
          programmeStartDate: '项目开始日期',
          programmeEndDate: '项目结束日期',
          enrollmentStatus: '注册状态',
        },
        status: {
          notEnrolled: '未注册',
          active: '活跃',
          inactive: '不活跃',
        },
        previewPanel: {
          enrolledFrom: '您自以下时间起已加入该项目：',
          ongoing: '至今',
        },
        noProgrammesNotice: '你的机构还没有开放任何可报名的项目。',
        noProgrammesTitle: '暂无项目',
        programmesUnknownNotice: '列表没有送达，这与没有项目不是一回事。',
        programmesUnknownTitle: '无法读取项目',
        retry: '重试',
        close: '关闭',
        confirmUnenroll: {
          title: '要退出该项目吗？',
          body: '您将退出{{programme}}。之后仍可重新加入。',
          cancel: '取消',
          confirm: '退出项目',
        },
      },
      observations: {
        addObservation: '添加测量',
        viewToggleLabel: '视图',
        viewCalendar: '日历',
        viewStack: '堆叠',
        viewTimeline: '时间线',
        filter: {
          title: '筛选',
          label: '项目',
          all: '所有项目',
        },
        submitting: '提交中...',
        searchBy: '搜索依据',
        searchValue: '搜索值',
        columns: '列',
        columnsLabel: '更改显示的列',
        eventType: '事件类型',
        dateTime: '日期时间',
        measurementType: '测量类型',
        value: '值',
        sourceDocument: '来源文档',
        sourceDocumentDescription: '文档描述',
        actions: '操作',
        eventTypes: {
          manualInput: '手动输入',
          deviceSync: '设备同步',
          uploaded: '已上传',
          coachingSession: '指导课程',
        },
        validation: {
          eventTypeRequired: '事件类型为必填项',
          dateTimeRequired: '日期和时间为必填项',
          invalidDateTime: '无效的日期和时间',
          atLeastOneMeasurement: '至少输入一个测量值',
          invalidValue: '无效值',
          validationFailed: '验证失败',
          fixErrors: '提交前请修复所有验证错误',
        },
        messages: {
          noChanges: '没有要保存的更改',
          successSingle: '观察保存成功',
          successMultiple: '成功提交所有观察条目！',
          submitError: '提交观察时出错',
          updateError: '更新观察时出错',
          deleteSuccess: '观察删除成功',
          removeSuccess: '观察已移除',
          deleteError: '删除观察时出错',
          loadError: '加载观察时出错',
          networkError: '发生网络错误',
          saveError: '保存更改时出错',
        },
        dialog: {
          deleteTitle: '删除观察',
          deleteMessage: '您确定要删除此观察事件吗？此操作无法撤销。',
          cancel: '取消',
          delete: '删除',
        },
        dayView: {
          previousDay: '前一天',
          nextDay: '后一天',
          today: '今天',
          noEntries: '这一天没有记录的观察数据',
          edit: '编辑',
          save: '保存',
          dataTypeNumber: '数字',
          dataTypeText: '文本',
          dataTypeBoolean: '是/否',
          noProgramme: '无项目',
          noValues: '未记录数值',
          newMeasurementTitle: '新测量',
          previewPending: '尚未保存',
          programme: '项目',
          selectProgramme: '选择一个项目',
          measurement: '测量项',
          selectMeasurement: '选择一个测量项',
          noMeasurementSelected: '请先选择测量项,再输入数值',
          noProgrammeSelected: '请先选择计划,再选择测量项',
          value: '数值',
          viewLabel: '视图',
          viewDay: '日',
          viewWeek: '周',
          viewMonth: '月',
          previousWeek: '上一周',
          nextWeek: '下一周',
          previousMonth: '上个月',
          nextMonth: '下个月',
          noEntriesRange: '此期间没有记录的观察数据',
          legendTitle: '项目',
          legendScheduledLabel: '计划测量',
          legendNotInProgramme: '不在项目中',
          dueLabel: '待记录',
          doneLabel: '已完成',
          dueTooltip: '{{measurement}} — {{programme}}',
          recordDue: '记录{{measurement}}',
          slotHint: '点击日历中任意空闲时间即可记录新内容',
          moreEvents: '还有 {{count}} 个',
        },
      },
      settings: {
        title: '语言和地区设置',
        language: '语言',
        region: '地区',
        systemOfMeasurement: '测量系统',
        timezone: '时区',
        metricSystem: '公制系统',
        imperialSystem: '英制系统',
        usCustomaryUnits: '美国惯用单位',
        regionInfoTitle: '地区信息',
        regionInfoText: '选择您的地区以本地格式显示数字、日期和时间（例如，美国：1,234.56, 03/07/2025, 5:30 PM；德国：1.234,56, 07.03.2025, 17:30）。',
        regionInfo: '选择您的地区以本地格式显示数字、日期和时间。',
        selectLanguage: '选择语言',
        selectRegion: '选择地区',
        selectMeasurement: '选择测量系统',
        selectTimezone: '选择时区',
        preview: '预览',
        formatExamples: '格式示例',
        save: '保存',
        cancel: '取消',
        saving: '保存中...',
        savedSuccessfully: '设置保存成功！',
        saveSuccess: '设置保存成功！',
        warningTitle: '确认更改',
        warningMessage: '这些更改将立即生效。语言更改将立即更新界面，而地区和测量设置将应用于所有显示的数据。',
        confirmSave: '保存更改',
        languageLabel: '语言',
        regionLabel: '地区',
        measurementLabel: '测量',
        numberLabel: '数字',
        dateLabel: '日期',
        timeLabel: '时间',
        weightLabel: '体重',
        heightLabel: '身高',
        distanceLabel: '距离',
        temperatureLabel: '温度',
        saveFailed: '无法保存您的设置。',
        languageSaveFailed: '无法保存您选择的语言。',
      },
      actions: {
        add: '添加',
        view: '查看',
        edit: '编辑',
        delete: '删除',
        save: '保存',
        cancel: '取消',
        close: '关闭',
        open: '打开',
      },
  recordPage: {
    path: '路径',
    general: '常规',
  },
  programmePage: {
    measurements: '测量',
    dashboards: '仪表板',
    notFoundTitle: '找不到此项目',
    notFoundBody: '它可能已被删除，或属于另一个组织。',
    loadFailedTitle: '无法读取此项目',
    loadFailed: '请稍后重试。',
  },
  programmeBoards: {
    loading: '正在加载仪表板',
    panelTitle: '此项目的仪表板',
    panelHint: '仪表板上有模块后，此项目的每位成员都会在自己的仪表板上看到它。保存后立即生效。',
    name: '名称',
    nameHint: '留空则使用项目名称。',
    unsaved: '未保存',
    save: '保存',
    discard: '放弃更改',
    saved: '已保存。此项目的成员现在可以看到它。',
    saveFailed: '无法保存仪表板。请重试。',
    emptyTitle: '此仪表板仍为空',
    emptyBody: '请在上方选择一个模块。仪表板有模块后，成员即可看到。',
    deniedTitle: '你无法更改此项目的仪表板',
    deniedBody: '这需要配置此项目的权限。',
    loadFailedTitle: '无法读取仪表板',
    retry: '重试',
    galleryHint: '选择一个模块，将其放在此仪表板底部。每个模块显示此项目的一项测量。',
    arrangeHint: '拖动模块的手柄，或拉动其右下角。每位成员会在其中看到自己的数值。',
    noMeasurements: '此项目尚未跟踪任何测量。请先在“测量”选项卡中添加。',
  },
  questionnairePage: {
    questions: '问题',
    submissions: '提交',
    notFoundTitle: '找不到此问卷',
    notFoundBody: '它可能已被删除，或属于另一个组织。',
    loadFailedTitle: '无法读取此问卷',
    loadFailed: '请稍后重试。',
  },
  tenantPage: {
    administrators: '管理员',
    notFoundTitle: '找不到此租户',
    notFoundBody: '它可能已被删除，或地址有误。',
    loadFailedTitle: '无法读取此租户',
    loadFailed: '请稍后重试。',
    table: {
      name: '姓名',
      email: '电子邮箱',
    },
    addButton: '添加管理员',
    remove: '移除',
    removeTitle: '移除管理员',
    removeMessage: '{{name}} 将不再管理 {{tenant}}。其账户以及与该组织的关联将保留。',
    removed: '已移除管理员',
    added: '已添加管理员',
    add: {
      title: '为 {{tenant}} 添加管理员',
      person: '人员',
      personRequired: '请选择一个人',
      nobody: '此组织中没有可以选择的人。',
      peopleFailed: '无法读取此组织的人员。',
      save: '添加',
      failed: '无法添加管理员。',
    },
  },
  grid: {
    noRowsTitle: '暂无内容',
    noRowsNotice: '一旦有数据，行就会出现。',
    noResultsTitle: '没有匹配项',
    noResultsNotice: '试试更短的搜索，或清除筛选条件。',
    actions: '操作',
    edit: '编辑',
    remove: '移除',
    clearSearch: '清除搜索',
    cancel: '取消',
    save: '保存',
    saving: '正在保存…',
    actionFailed: '操作未成功，未做任何更改。',
    loadFailedTitle: '无法读取此列表',
    add: '添加',
    filter: '筛选',
    searchAll: '搜索所有列',
    sortByField: '排序方式：{{field}}',
    sortByFieldDirection: '排序方式：{{field}}，{{direction}}',
    filterWithCount: '筛选（{{count}}）',
    newestFirst: '最新优先',
    noResultsFor: '没有与“{{query}}”匹配的结果',
    clearSearchAndFilters: '清除搜索和筛选',
    tryAgain: '重试',
    rowsPerPage: '每页行数',
    range: '第 {{from}}–{{to}} 条，共 {{count}} 条',
    previousPage: '上一页',
    nextPage: '下一页',
  },
  coaches: {
    title: '教练',
    subtitle: '你所在机构提供的教练。由你决定向谁提出请求，以及对方可以看到你的哪些测量值。',
    coachingSubtitle: '你指导的人、向你提出的请求，以及教练名录如何展示你。',
    unnamedCoach: '未署名的教练',
    unnamedMember: '未署名的成员',
    requestPendingChip: '请求已发送',
    ask: '向这位教练提出请求',
    details: '详情',
    withdrawRequest: '撤回请求',
    access: {
      held: '可以查看你的 {{see}} 项测量值，可以录入 {{record}} 项。',
      asked: '请求查看 {{see}} 项测量值，并录入 {{record}} 项。',
    },
    cannotAsk: {
      alreadyMyCoach: '这位教练已经在看你的测量值。',
      requestPending: '你的请求仍在等待答复。',
      notAccepting: '这位教练目前不接收新的人。',
    },
    askTitle: '向 {{name}} 提出请求',
    askExplainer:
      '选择这位教练可以看到的内容。你可以随时在“你的教练”中更改或结束。',
    measurement: '测量项',
    maySee: '可以查看',
    mayRecord: '可以录入',
    maySeeAria: '可以查看 {{name}}',
    mayRecordAria: '可以录入 {{name}}',
    messageLabel: '留言（可选）',
    sendRequest: '发送请求',
    askFailed: '请求未能发送。',
    scopesUnavailable: '无法读取你所在项目的测量项。',
    noProgrammeYet:
      '你还没有参加任何项目，而可分享的内容来自项目。',
    someUnsharable:
      '暂时无法分享：{{names}}。这些测量项没有 LOINC 代码，请让管理员绑定一个。',
    noMeasurementsYet: '你的项目还没有指定测量项，因此暂时没有可分享的内容。',
    waitingForYou: '等待你的答复',
    stillWaiting: '仍在等待答复',
    earlierRequests: '较早的请求',
    offeredAccess: '对方请求的内容',
    sharedProgrammes: '你们共同的项目',
    askedOn: '于 {{when}} 提出',
    answerableUntil: '可在 {{when}} 之前答复',
    expiredOn: '于 {{when}} 过期',
    expired: '已过期',
    accept: '接受',
    decline: '拒绝',
    declineTitle: '拒绝请求',
    declineReasonLabel: '原因（可选）',
    actionFailed: '操作未成功。',
    status: {
      pending: '等待答复',
      accepted: '已接受',
      declined: '已拒绝',
      withdrawn: '已撤回',
      expired: '已过期',
    },
    myListing: '你的教练资料',
    myListingExplainer: '只有你能把这份资料放进名录。它与你的社区分享设置无关。',
    listingSaved: '教练资料已保存。',
    saveFailed: '资料未能保存。',
    headlineLabel: '一句话介绍',
    bioLabel: '关于你',
    programmesLabel: '你带的项目',
    maxMembersLabel: '最多人数',
    maxMembersHelp_one: '你目前带 {{count}} 人。',
    maxMembersHelp_other: '你目前带 {{count}} 人。',
    acceptingLabel: '接收新的人',
    publishLabel: '在我的机构中展示',
    publishNeedsBoth: '进入名录的资料需要一句话介绍和关于你的说明：别人正是据此选择。',
    peopleYouFollow: '你带的人',
    peopleYouFollowExplainer: '你能看到某人的哪些内容，由本人决定。',
    directoryUnknown: '无法读取名录',
    directoryUnknownNotice: '请稍后再试。',
    onlyYouListedTitle: '你是名录中唯一的教练',
    onlyYouListedNotice:
      '你所在机构还没有其他教练发布资料。',
    noneListedTitle: '名录中还没有教练',
    noneListedNotice: '你所在机构的教练一旦发布资料，就会出现在这里。',
    canAsk: '你可以提出请求的教练',
    allAlreadyYoursTitle: '暂无其他教练',
    allAlreadyYoursNotice: '已经在带你的教练列在上方。你所在机构的其他教练一旦发布资料，就会出现在这里。',
    onlyAccepting: '仅显示接收新的人的教练',
    search: '搜索教练',
    noneAcceptingTitle: '目前没有人接收新的人',
    noneAcceptingNotice: '名录中的教练目前都不接收新的人。',
    listingUnknownTitle: '无法读取你的教练资料',
    listingUnknown: '这里显示的内容可能不是最新的。',
    noListingTitle: '你还没有教练资料',
    noListing:
      '教练在此页面编辑成员看到的资料。你的账号没有教练角色，因此这里暂时没有可编辑的内容。',
    grantsUnknownTitle: '无法读取你的教练列表',
    grantsUnknown: '这里显示的内容可能不是最新的。',
    noneMatchTitle: '没有找到教练',
    noneMatchNotice: '没有与“{{query}}”匹配的结果。试试姓名或计划的一部分。',
    myCoaches: '你的教练',
    changeOnCoaches: '要更改教练可以查看哪些测量项，请前往“教练”页面。',
    whatTheyMaySee: '对方可以查看的内容',
    sinceExplainer: '你于 {{when}} 授予了这项访问权限。更改立即生效。',
    saveAccess: '保存更改',
    accessSaved: '更改已保存。',
    accessSaveFailed: '更改未能保存。',
    keepOneOrEnd:
      '请至少保留一项测量项，或者直接结束访问 —— 这样教练也会知道。',
    nothingShared: '没有向这位教练分享任何内容。',
    accessEndedOn: '这项访问权限已于 {{when}} 结束。',
    offerUnreadable:
      '无法读取你所在项目的测量项，因此这里只列出已经分享的内容。',
    endCoaching: '结束访问',
    endCoachingTitle: '结束访问',
    endCoachingBody: '{{name}} 之后将无法查看你的测量值。已经记录的内容会保留。',
    grantedOn: '于 {{when}} 授予访问权限',
    endedCoaching: '已结束的陪伴',
    endedOn: '于 {{when}} 结束',
    revokeFailed: '未能结束访问。',

    tabs: {
      coaches: '我的教练',
      history: '历史记录',
      listing: '我的教练资料',
      requests: '发给我的请求',
      members: '我指导的人',
    },

    noProgrammeTitle: '您还没有参加任何计划',
    noProgrammeNotice: '教练是围绕计划提供指导的。参加计划后，指导该计划的教练会显示在这里。',
    noHistoryTitle: '还没有可回顾的内容',
    noHistoryNotice: '已结束的指导和没有下文的请求都保存在这里。',
    peopleYouCoached: '您指导过的人',
    noPastMembersTitle: '还没有人结束',
    noPastMembersNotice: '你指导的人都还在。结束的指导会记录在这里。',
    noOpenRequestsTitle: '没有等待处理的请求',
    noOpenRequestsNotice: '有人请你指导时，他们的请求会出现在这里。',
    answeredRequests: '已回复的请求',
    noMembersYetTitle: '你还没有指导任何人',
    noMembersYetNotice: '有人接受你的请求后，会连同他们允许你查看的内容出现在这里。',
    memberUnreadableTitle: '无法读取这些测量数据',
    memberUnreadable: '请稍后再试。',
    nothingPermittedTitle: '没有可显示的内容',
    nothingPermittedNotice: '此人的计划中没有可以与你共享的测量项。',
    nothingSharedWithYouTitle: '还没有共享任何内容',
    nothingSharedWithYouNotice: '此人尚未与你共享任何测量数据。下面列出了可以共享的项目。',
    notShared: '未与你共享',
    notSharedNotice: '此人没有共享该测量项，因此不显示相关内容。',
    sourceUnavailable: '数据源未响应',
    sourceIncomplete: '部分无法读取',
    sourceIncompleteNotice: '此来源发送的部分数值无法读取，因此此处显示的并非全部。',
    sourceSilent: '保存这些数值的数据源未响应',
    sourceRefused: '无法代你读取数据源',
    sourceNotReadForYou: '无法代你读取保存这些数值的数据源',
    recordedHere: '记录在本平台',
    fromSourceAsOf: '来自 {{source}}，获取于 {{when}}',
    asOfUnknown: '时间不详',
    mixedSources: '数值来自 {{places}} 个不同的数据源，因此不显示变化量。',
    sourcesDegradedTitle: '可能缺少部分数值',
    sourcesDegraded: '{{names}} 未响应。保存在那里的数值可能未显示在此屏幕上。',
    sourcesRefusedTitle: '部分数值无法显示',
    sourcesRefused: '无法代你读取 {{names}}，因此保存在那里的数值未显示在此屏幕上。这与该数据源和本平台之间的访问权限有关，与此人和你共享的内容无关。',
    sourceNotConnectedChip: '未连接',
    sourceNotConnectedCaption: '连接你自己的账户，以读取此数据源中保存的数值',
    sourcesNotConnectedTitle: '连接后可读取部分数值',
    sourceNotConnected: '{{name}} 只能用你自己的账户读取。连接一次后，此人与你共享的数值即可在此显示。',
    sourceReconnect: '你与 {{name}} 的连接已结束，因此保存在那里的数值未显示在此屏幕上。请重新连接，以读取此人与你共享的内容。',
    connectSource: '连接 {{name}}',
    reconnectSource: '重新连接 {{name}}',
    connectedTitle: '已连接到 {{source}}',
    connectedBody: '请重新打开此人，以读取共享的数值。',
    connectFailedTitle: '无法建立连接',
    connectFailedBody: '未作任何更改。请稍后再试。',
    notConnectedTitle: '未连接到 {{source}}',
    connectReasons: {
      refused: '{{source}} 未接受登录，因此未连接任何内容。',
      no_code: '在 {{source}} 的登录没有返回任何内容，因此未连接任何内容。',
      no_party_id: '你在 {{source}} 的账户尚无 JLAM ID，因此无法在那里指明你。请询问管理账户的人。',
      no_person: '你在此处的账户未关联到任何人，因此无法连接。',
    },
    sourcesStaleTitle: '部分数值可能不是最新的',
    sourcesStale: '无法刷新 {{names}}。自上次检查以来保存在那里的数值未显示在此屏幕上。',
    withheldFromHistory: '未与你共享：{{names}}',
    source: '数据源',
    asOf: '获取时间',
    here: '本平台',
    lastRecorded: '最近记录于 {{when}}',
    lastRecordedByYou: '最近由你记录于 {{when}}',
    noReadingYet: '尚未记录数值',
    readOnlyHere: '仅可查看',
    newValue: '新数值',
    unit: '单位',
    measuredAt: '测量时间',
    momentInFuture: '测量时间不能设在未来。',
    recordedSome_one: '已记录 {{count}} 个数值，其余未能记录。',
    recordedSome_other: '已记录 {{count}} 个数值，其余未能记录。',
    record: '记录',
    recorded_one: '已记录 {{count}} 个数值。',
    recorded_other: '已记录 {{count}} 个数值。',
    recordFailed: '无法记录该数值。',
    nothingToRecord: '请先填写一个数值。',
    valueNotANumber: '此测量项需要填写数字。',
    requestSent: '请求已发送给 {{name}}。',
    requestAccepted: '你现在指导 {{name}}。',
    requestDeclined: '已拒绝 {{name}} 的请求。',
    requestWithdrawn: '已撤回发给 {{name}} 的请求。',
    accessEnded: '{{name}} 不能再查看你的测量数据。',
    findSomeoneYouCoach: '查找你指导的人',
    personColumn: '成员',
    sinceColumn: '开始于',
    trendColumn: '趋势',
    lastActivityColumn: '最近记录',
    lastActivityNever: '尚无记录',
    lastActivityOn: '最近记录于 {{when}}',
    searchMembers: '在你指导的人中搜索',
    noMatchesTitle: '没有匹配的人',
    noMatchesNotice: '试试更短的搜索词，或清空输入框。',
    openMember: '打开 {{name}}',
    caseloadUnknownTitle: '无法读取你指导的人',
    caseloadUnknownNotice: '请稍后再试。',
    jumpToAnother: '前往其他人',
    memberNotInCaseloadTitle: '不是你指导的人',
    memberNotInCaseloadNotice: '此人不在你的列表中。指导可能已结束，或链接已过期。',
    trendNothing: '尚未共享任何内容',
    trendInRange_one: '{{count}} 项在目标范围内',
    trendInRange_other: '{{count}} 项在目标范围内',
    trendToward_one: '{{count}} 项正在接近目标',
    trendToward_other: '{{count}} 项正在接近目标',
    trendAway_one: '{{count}} 项正在远离目标',
    trendAway_other: '{{count}} 项正在远离目标',
    trendTracked_one: '已跟踪 {{count}} 项测量',
    trendTracked_other: '已跟踪 {{count}} 项测量',
    coachingSince: '自 {{when}} 起指导',
    viewTrends: '趋势',
    viewHistory: '历史',
    recordedAt: '记录时间',
    value: '数值',
    recordedBy: '记录者',
    you: '你',
    noReadingsTitle: '还没有记录',
    noReadingsNotice: '为此人记录的数值会显示在这里，最新的在前。',
  },
  manageRoles: {
    noTenantNotice: '角色属于机构，而此账户不属于任何机构。',
    noTenantTitle: '没有可显示角色的机构',
  },
  look: {
    title: '标志与颜色',
    symbol: {
      title: '标志',
      description: '在导航栏中显示在 tenant 名称旁边，所有成员都能看到。它属于组织，因此该组织的所有 tenant 显示同一个标志。',
      preview: '标志在导航栏中的样子',
      none: '尚未设置标志。成员只会看到 tenant 名称。',
      accepted: 'PNG 或 WebP，最大 512 KB，至少 64 × 64 像素。',
      choose: '选择图片',
      save: '保存标志',
      saved: '标志已保存。',
      remove: '移除标志',
      removed: '标志已移除。',
      refused: '无法使用此文件。请选择最大 512 KB、至少 64 × 64 像素的 PNG 或 WebP 图片。',
      error: '标志无法保存。请重试。',
    },
    profiles: {
      title: '颜色方案',
      description: '在成员自己选择之前，他们看到的是默认方案。MLP 的标准方案始终与你们自己的方案一起提供。',
      standard: 'MLP 标准方案',
      own: '此 tenant 的方案',
      default: '默认',
      makeDefault: '设为默认',
      defaultSaved: '{{name}} 现在是默认方案。',
      edit: '编辑颜色',
      history: '历史记录',
      add: '添加方案',
      newName: '方案名称',
      create: '保存方案',
      added: '{{name}} 已作为版本 1 添加。',
      duplicateName: '此 tenant 已有同名方案。请换一个名称。',
      loadError: '无法加载颜色方案。请重新加载页面后重试。',
      saveError: '更改无法保存。请重试。',
    },
    editor: {
      title: '{{name}} 的颜色',
      newTitle: '新颜色方案',
      hexLabel: '{{role}} 的十六进制值',
      variants: '较浅、主色和较深变体，以及主色上的文字颜色',
      textSample: '文字',
      contrastIntro: '使用这些颜色时文字难以阅读。请修改下面指出的颜色：',
      contrastFailure: '{{role}}，{{pairing}}：{{ratio}}:1，至少需要 {{required}}:1',
      pairing: {
        textOnColour: '此颜色上的文字',
        linkOnPaper: '作为白色背景上的链接文字',
        linkOnPage: '作为页面背景上的链接文字',
      },
      save: '另存为新版本',
      saved: '已保存为版本 {{version}}。',
      reset: '恢复为 Meridian',
      close: '关闭',
    },
    history: {
      title: '{{name}} 的历史记录',
      version: '版本 {{version}}',
      savedBy: '{{when}}，由 {{who}}',
      savedAt: '{{when}}',
      current: '使用中',
      rollBack: '回退到此版本',
      rolledBack: '已回退。已保存为版本 {{version}}。',
      loadError: '无法加载历史记录。',
      rollBackError: '回退无法保存。请重试。',
    },
    preview: {
      title: '预览',
      navigationCurrent: '仪表板',
      navigationOther: '测量',
      button: '保存',
      secondButton: '添加',
      link: '一个链接',
      chart: '一周内的一项测量及其目标范围',
    },
    roles: {
      primary: {
        name: '主色',
        hint: '导航、按钮、链接和焦点',
      },
      secondary: {
        name: '第二颜色',
        hint: '次要按钮和强调',
      },
      success: {
        name: '在范围内',
        hint: '处于应有位置的数值，以及已完成的事项',
      },
      warning: {
        name: '偏离目标',
        hint: '偏离目标的数值',
      },
      error: {
        name: '错误',
        hint: '错误以及现在需要关注的事项',
      },
      info: {
        name: '信息',
        hint: '中性提示',
      },
    },
    standard: {
      meridian: 'Meridian',
      lagune: '湖水绿',
      classic: '经典',
    },
    choice: {
      title: '颜色方案',
      description: '应用在你眼中的样子。保存个人资料后，你的选择即生效，并在其他设备上同样适用。',
      followTenant: '{{tenant}} 的默认方案（{{name}}）',
      followMeridian: 'MLP 默认方案（Meridian）',
      loadError: '无法加载颜色方案。',
    },
  },
  valueDetail: {
    title: '此数值的来源',
    traceTitle: '此数值的追溯',
    loading: '正在读取此数值的来源',
    missing: '没有此编号的数值。',
    failed: '无法读取此数值的来源。',
    retry: '重试',
    value: '数值',
    time: '时间',
    notKnown: '关于此数值没有更多信息。',
    recorded: '记录时的样子',
    code: '代码',
    codeSystem: '代码体系：{{system}}',
    source: '来源',
    sources: {
      manualInput: '由你输入',
      deviceSync: '来自已连接的来源',
      uploaded: '来自文档',
      coachingSession: '来自教练',
    },
    shownAs: '显示为',
    converted: '换算方式',
    noConversion: '未换算：按记录时的样子显示。',
    conversion: {
      algebra: '1 {{from}} = {{factor}} {{to}}，于 {{date}} 确认。',
      molarMass: '1 {{from}} = {{factor}} {{to}}，通过 {{analyte}} 的摩尔质量（{{mass}} g/mol，来源：{{source}}），于 {{date}} 确认。',
    },
    reference: '参考',
    changedSince: '此后的变更',
    notChanged: '此后代码没有变更。',
    laterRelease: '该数值记录之后，较新的版本更改了此代码。',
    change: '{{field}}：{{from}} → {{to}}（{{date}}）',
    showFullOrigin: '显示完整来源',
    close: '关闭',
    graphLabel: '读数。用方向键在它们之间移动。',
    graphOpenHint: '按 Enter 键打开。',
  },
  groupingLevels: {
    label: '数值的计入范围',
    loading: '正在读取层级',
    loadFailed: '无法读取层级。当前保存的层级保持不变。',
    THIS_CODE: {
      name: '仅此代码',
      help: '只计入以这个确切代码记录的数值。',
    },
    ANY_METHOD: {
      name: '同一事物，不论方法',
      help: '同一事物的数值都会计入，无论是在家还是在诊所测得。',
    },
  },
    };

export default { translation };
